import React from 'react';
import { Icon } from '@b-design/fusion';
import { Col, Row } from 'antd';
import $i18n from '@/i18n';
import { formatTime } from '@/utils';

import './index.less';
import DefaultAppIcon from '@/components/DefaultAppIcon';
interface VersionDescription {
  name: string;
  appId: string;
  iconPublicUrl: string;
  slogan: string;
  description: string;
  customerEmail: string;
  customerPhone: string;
}
interface App {
  framework: string;
}
interface VersionInfos {
  createName: string;
  gmtCreate: string;
  gmtModified: string;
  versionStatus: string;
  channelName: string;
  version: string;
  changelog: string;
  versionDescription: VersionDescription;
  app: App;
}
interface Props {
  versionInfos: VersionInfos;
}

const VersionInfo: React.FC<Props> = ({ versionInfos }) => {
  const {
    createName,
    gmtCreate,
    gmtModified,
    versionDescription,
    channelName,
    version,
    changelog,
    app,
    versionStatus,
  } = versionInfos;
  // const { name, appId, icon, slogan, description, customerEmail, customerPhone } = versionDescription;

  const renderPhone = (v) => {
    let text = '';
    if (v !== '-') {
      if (v?.split('-')[0]) {
        text = `+${v?.split('-')[0]} ${v?.split('-')[1]}`;
      } else {
        text = `${v?.split('-')[1]}`;
      }
    } else {
      text = '';
    }
    return text;
  };

  return (
    <div className="info-container">
      <Row>
        <Col flex="160px">
          <div className="info-item">
            <div className="info-icon">
              <Icon type="mobile--outline" size="xs" />
            </div>
            <div>
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Released.By',
                dm: '发布者',
              })}
            </div>
          </div>
        </Col>
        <Col flex="auto">
          <div className="info-dec">{createName}</div>
        </Col>
      </Row>
      <Row>
        <Col flex="160px">
          <div className="info-item">
            <div className="info-icon">
              <Icon type="package--outline" size="xs" />
            </div>
            <div>
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Released.On',
                dm: '发布时间',
              })}
            </div>
          </div>
        </Col>
        <Col flex="auto">
          <div className="info-dec">{formatTime(gmtCreate) || ''}</div>
        </Col>
      </Row>
      <Row>
        <Col flex="160px">
          <div className="info-item">
            <div className="info-icon">
              <Icon type="equipment--outline" size="xs" />
            </div>
            <div>
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Last.Modified.On',
                dm: '上次修改时间',
              })}
            </div>
          </div>
        </Col>
        <Col flex="auto">
          <div className="info-dec">{formatTime(gmtModified) || ''}</div>
        </Col>
      </Row>
      {versionStatus !== 'CREATED' &&
        versionStatus !== 'APPROVE' &&
        versionStatus !== 'REJECT' &&
        versionStatus !== 'WITHDRAW' && (
          <>
            <div className="info-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.App.information',
                dm: '应用程序信息',
              })}
            </div>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="mobile--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Miniapp.Name',
                      dm: 'Miniapp名称',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{versionDescription?.name}</div>
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="mobile--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.ID',
                      dm: '编号',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{versionDescription?.appId}</div>
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="apps--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Type',
                      dm: '类型',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{app?.framework}</div>
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="apps--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Logo',
                      dm: '标志',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                {versionDescription?.iconPublicUrl ? (
                  <img className="logo" src={versionDescription?.iconPublicUrl} />
                ) : (
                  <DefaultAppIcon className="logo" />
                )}
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="wikis--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Slogan',
                      dm: '标语',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{versionDescription?.slogan}</div>
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="document--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Description',
                      dm: '描述',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{versionDescription?.description}</div>
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="document--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Contact.number',
                      dm: '联系电话',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{renderPhone(versionDescription?.customerPhone)}</div>
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="document--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Contact.email',
                      dm: '联系邮箱',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{versionDescription?.customerEmail}</div>
              </Col>
            </Row>
            <div className="info-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Version.information',
                dm: '版本信息',
              })}
            </div>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="package--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Target.app',
                      dm: '目标程序',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{channelName}</div>
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="equipment--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Version',
                      dm: '版本',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">v{version}</div>
              </Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="folder--details--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Release.Note',
                      dm: '发布说明',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{changelog}</div>
              </Col>
            </Row>
          </>
        )}
    </div>
  );
};
export default VersionInfo;
